import "@/App.css";
import "@/index.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";

const Home = lazy(() => import("./pages/Home"));
const Blog = lazy(() => import("./pages/Blog"));
const CategoriesIndex = lazy(() => import("./pages/CategoriesIndex"));
const CategoryPage = lazy(() => import("./pages/Category"));
const Article = lazy(() => import("./pages/Article"));
const About = lazy(() => import("./pages/About"));
const Disclosure = lazy(() => import("./pages/Disclosure"));
const Privacy = lazy(() => import("./pages/Privacy"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const Terms = lazy(() => import("./pages/Terms"));
const LegalNotice = lazy(() => import("./pages/LegalNotice"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Reserves the viewport height so the footer does not jump while a chunk loads.
const routeFallback = <div className="min-h-screen" aria-hidden="true" />;

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={routeFallback}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/guide" element={<Blog />} />
            <Route path="/categorie" element={<CategoriesIndex />} />
            <Route path="/categoria/:slug" element={<CategoryPage />} />
            <Route path="/guida/:slug" element={<Article />} />
            <Route path="/best-of/:slug" element={<Article />} />
            <Route path="/chi-sono" element={<About />} />
            <Route path="/disclosure" element={<Disclosure />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie" element={<CookiePolicy />} />
            <Route path="/termini" element={<Terms />} />
            <Route path="/note-legali" element={<LegalNotice />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
